var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePictureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18C4.5 10.5442 10.5442 4.5 18 4.5V4.5C25.4558 4.5 31.5 10.5442 31.5 18V18C31.5 25.4558 25.4558 31.5 18 31.5V31.5C10.5442 31.5 4.5 25.4558 4.5 18V18Z",
    fill: "#7E869E",
    fillOpacity: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 15,
    r: 6,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3802 27.4512C27.4373 27.5482 27.4196 27.6713 27.3383 27.7492C24.9135 30.0725 21.6235 31.5 18.0001 31.5C14.3767 31.5 11.0867 30.0725 8.66188 27.7493C8.58062 27.6715 8.56291 27.5483 8.62 27.4514C10.3489 24.5143 13.9001 22.5 18.0001 22.5C22.1002 22.5 25.6513 24.5142 27.3802 27.4512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePictureIcon);
export default __webpack_public_path__ + "static/media/ProfilePictureIcon.7c186eda7ccb4740c77d2f3681d0206f.svg";
export { ForwardRef as ReactComponent };